import { render } from 'preact';
import { App } from '@/App';
import { recipes } from '@/recipes/_generated';
import './styles.css';
import { initTheme } from '@/theme';
import { validateRecipe } from '@/validateRecipe';

initTheme();
const knownSlugs = new Set(recipes.map((r) => r.slug));
for (const { slug, recipe } of recipes) validateRecipe(slug, recipe, knownSlugs);

const root = document.getElementById('app');
if (root) render(<App />, root);
